export enum ProductLifecycleStage {
    A1RawMaterialSupply = 'A1',
    A2CradleToGate = 'A2',
    A3Production = 'A3',
    A4TransportToFinalDestination = 'A4',
    B1UsagePhase = 'B1',
    B2Maintenance = 'B2',
    B3Repair = 'B3',
    B5UpdateUpgradeRefurbishing = 'B5',
    B6UsageEnergy = 'B6',
    B7UsageWater = 'B7',
    C1Reassembly = 'C1',
    C2TransportToRecycler = 'C2',
    C3Recycling = 'C3',
    C4Landfill = 'C4',
    DReuse = 'D',
}
